import { useState } from 'react';
import AlertWithIcon from '../AlertWithIcon';
import { TruncateString } from '../../lib/helpers/StringHelper';
import { P2GText, P2GLink } from '@parcel2go/core-ui';

interface props {
  message: string;
  isXs: boolean;
}

const BannersItem = (props: props) => {
  const [open, setOpen] = useState(false);
  return (
    <AlertWithIcon color="info">
      {props.isXs && !open ? (
        <>
          <P2GText component="p" variant="body2">
            {TruncateString(props.message, 40)}{' '}
          </P2GText>
          <P2GLink onClick={() => setOpen(true)}>Show Message</P2GLink>
        </>
      ) : (
        <P2GText component="p" variant="body2">
          {props.message}
        </P2GText>
      )}
    </AlertWithIcon>
  );
};
export default BannersItem;
